module.exports = __webpack_public_path__ + "0821ba36.svg";